import React from 'react'
import { useWizard } from '@/components/common/wizard/WizardContext'
import { formatCurrencyAutoLocale } from '@/utils/tools'
import { parseBudgetAmount } from '@/utils/audience-builder'
import {
    ADVANTAGE_LEADS_LABEL,
    FAIR_SPLIT_NOTE,
    PLACEMENTS_NOTE,
    isAdvantageLeadsBudget,
} from '@/utils/advantage-leads'

interface WizardContextType {
    getStepContentData: (stepName: string) => any
}

interface AdvantageLeadsReviewProps {
    currency?: string
}

/** The budget mode of a campaign with one Advantage+ leads campaign budget, on the review step. */
const AdvantageLeadsReview: React.FC<AdvantageLeadsReviewProps> = ({ currency }) => {
    const { getStepContentData } = useWizard() as WizardContextType
    const budgetData = getStepContentData('budgetSchedule')
    if (!isAdvantageLeadsBudget(budgetData)) return null

    const amount = parseBudgetAmount(budgetData.campaignBudget) || 0

    return (
        <div
            className="tw:mx-6 tw:mt-6 tw:flex tw:flex-col tw:gap-2 tw:rounded-lg tw:border tw:p-4"
            data-testid="advantage-leads-review"
        >
            <span className="tw:text-sm tw:font-semibold">{ADVANTAGE_LEADS_LABEL}</span>
            <p className="tw:text-sm">
                {`${formatCurrencyAutoLocale({ amount, currency })} a day for the whole campaign, shared by Meta across the audiences.`}
            </p>
            <p className="tw:text-sm">{PLACEMENTS_NOTE}</p>
            <p className="tw:text-xs tw:text-gray-200">{FAIR_SPLIT_NOTE}</p>
        </div>
    )
}

export default AdvantageLeadsReview
